<h1 class="h3 mb-2 text-gray-800">Casos</h1>

<div class="card shadow mb-4">
    <div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary">Caso para aprobar</h6>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label>
                        Paciente
                    </label>
                    <div>{{caso.paciente}}</div>
                </div>
                <div class="form-group">
                    <label>
                        Género
                    </label>
                    <div>{{generos[caso.genero]}}</div>
                </div>
                <div class="form-group">
                    <label>
                        Fecha de Nacimiento
                    </label>
                    <div>{{caso.fechaNacimiento}}</div>
                </div>
                <div class="form-group">
                    <label>
                        Fecha de Envío
                    </label>
                    <div>{{getFormattedDate(caso.created_at)}}</div>
                </div>
                <div class="form-group">
                    <label>
                        Código de Paciente
                    </label>
                    <div>{{caso.ci}}</div>
                </div>
                <div class="row">
                    <div class="col-4 offset-4">
                        <div class="form-group">
                            <label>
                                Foto Superior
                            </label>
                            <div>
                                <a class="caso-foto" href="{{getImageUrl('foto-superior')}}" target="_blank"><img
                                        src="{{getImageUrl('foto-superior')}}" /></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <div class="form-group">
                            <label>Foto Lateral Der</label>
                            <div>
                                <a class="caso-foto" href="{{getImageUrl('foto-derecha')}}" target="_blank"><img
                                        src="{{getImageUrl('foto-derecha')}}" /></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="form-group">
                            <label>Frente Intraoral</label>
                            <div>
                                <a class="caso-foto" href="{{getImageUrl('frente-intraoral')}}" target="_blank"><img
                                        src="{{getImageUrl('frente-intraoral')}}" /></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="form-group">
                            <label>Foto Lateral Izq</label>
                            <div>
                                <a class="caso-foto" href="{{getImageUrl('foto-izquierda')}}" target="_blank"><img
                                        src="{{getImageUrl('foto-izquierda')}}" /></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4 offset-4">
                        <div class="form-group">
                            <label>Foto Inferior</label>
                            <div>
                                <a class="caso-foto" href="{{getImageUrl('foto-inferior')}}" target="_blank"><img
                                        src="{{getImageUrl('foto-inferior')}}" /></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <div class="form-group">
                            <label>Frente Facial</label>
                            <div>
                                <a class="caso-foto" href="{{getImageUrl('frente-facial')}}" target="_blank"><img
                                        src="{{getImageUrl('frente-facial')}}" /></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="form-group">
                            <label>Frente Facial Sonrisa</label>
                            <div>
                                <a class="caso-foto" href="{{getImageUrl('frente-facial-sonrisa')}}"
                                    target="_blank"><img src="{{getImageUrl('frente-facial-sonrisa')}}" /></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="form-group">
                            <label>Perfil facial</label>
                            <div>
                                <a class="caso-foto" href="{{getImageUrl('perfil-facial')}}" target="_blank"><img
                                        src="{{getImageUrl('perfil-facial')}}" /></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <ng-container *ngIf="isAdmin">
                        <button type="submit" class="btn btn-success" (click)="aprobarCaso()">Aprobar
                            Caso</button>&nbsp;
                        <button type="submit" class="btn btn-primary"
                            (click)="rechazar(rechazarModal)">Rechazar</button>
                    </ng-container>
                    <a [routerLink]="'/casos/'+caso.id+'/verpaciente'" class="btn btn-link">Volver</a>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #rechazarModal let-modal>
    <form name="form" (ngSubmit)="f.form.valid && confirmarRechazo()" #f="ngForm">
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">Rechazar</h4>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="form-group">
                <label for="dateOfBirth">Motivo de Rechazo</label>
                <textarea [(ngModel)]="caso.motivo_rechazo" class="form-control" name="motivoRechazo"
                    #motivoRechazo="ngModel" [ngClass]="{'is-invalid':  f.submitted && motivoRechazo.invalid}"
                    required></textarea>
                <div *ngIf="f.submitted && motivoRechazo.invalid" class="invalid-feedback">
                    <div *ngIf="motivoRechazo.errors.required">El motivo es requerido</div>
                </div>
            </div>

        </div>
        <div class="modal-footer">
            <button type="submit" class="btn btn-outline-dark">Confirmar Rechazo</button>
        </div>
    </form>
</ng-template>